import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idEmployeeExpenseReport']),
    },
    mutations: {
        ...functions.createDefaultMutations(['idEmployeeExpenseReport'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idEmployeeExpenseReport'])
    },
}